import { useRouter } from 'next/router';
import React from 'react';
import { images } from '../../../../Constants/ImageUrls';
import AnywhereHorizontalScroll from '../../../HelperComponents/AnywhereHorizontalScroll';
import { productStaticData } from '../../staticData';
import ProductCarouselInner from './ProductCarouselInner';
import { ProductContainer } from './styled';

function ProductCarousel(props) {
  const router = useRouter();

  return (
    <ProductContainer>
      <p className="heading">PRODUCTS YOU MAY LIKE</p>
      <AnywhereHorizontalScroll
        firstElementId={`0first`}
        lastElementId={`${productStaticData?.length - 1}last`}
        leftArrow={<img src={images.arrowDownForward} alt="scrollArrow" />}
        rightArrow={<img src={images.arrowDownForward} alt="scrollArrow" />}
        scrolledWidth={440}
      >
        {productStaticData?.map((element, index) => {
          return (
            <ProductCarouselInner
              key={`prod_${index}`}
              element={element}
              index={index}
            />
          );
        })}
      </AnywhereHorizontalScroll>
    </ProductContainer>
  );
}

export default ProductCarousel;
